import { createPermission } from '@backstage/plugin-permission-common';

export const techdocsFeedbackReadPermission = createPermission({
  name: 'techdocs.feedback.read',
  attributes: { action: 'read' },
});

export const techdocsFeedbackUpdatePermission = createPermission({
  name: 'techdocs.feedback.update',
  attributes: { action: 'update' },
});

export const techdocsFeedbackPermissions = [
  techdocsFeedbackReadPermission,
  techdocsFeedbackUpdatePermission,
];
